<template>
  <div class="border-b border-gray1 px-1 py-2" :class="{ 'cursor-pointer': hasDetail }" @click="handleClick">
    <div class="flex items-center justify-between">
      <h3 class="text-xl font-medium leading-7 tracking-[0.5px] text-[#1A150E] md:text-gray9">{{ heading }}</h3>
      <button v-if="hasDetail" aria-label="Show details" class="things-to-know-arrow flex-shrink-0 md:text-gray9" type="button">
        <span class="material-symbols-sharp">chevron_right</span>
      </button>
    </div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div
      v-if="summary"
      class="things-to-know-summary flex items-center gap-2 px-1 py-2 text-sm text-black2 md:block md:px-1 md:py-2 md:text-base md:leading-6 md:text-gray4"
      @click="handleSummaryClick"
      v-html="summary"
    ></div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  heading: string;
  summary?: string;
  hasDetail: boolean;
  onOpenDetail?: () => void;
}
const props = defineProps<Props>();
const handleClick = () => {
  if (props.hasDetail) {
    props.onOpenDetail?.();
  }
};
const handleSummaryClick = (event: MouseEvent) => {
  if ((event.target as HTMLElement).tagName === 'A') {
    event.stopPropagation();
    return;
  }
  handleClick();
};
</script>

<style lang="scss">
.things-to-know-arrow {
  color: var(--foreground-fg-primary, var(--Foreground-emphasis, #1a150e));
  font-size: var(--font-size-IconFont, 24px);
  font-style: normal;
  font-weight: 100;
  line-height: var(--line-height-IconFont, 24px);
}

.things-to-know-summary {
  p {
    margin: 0;
  }
  a {
    color: #826b3d;
    text-decoration: underline;
  }
}
</style>
